import { useAppForm as useAppFormBase } from '@worldcoo/ui/components/form';
import { loadRecaptcha } from '@worldcoo/ui/lib/captcha';
import { useZodI18n } from './zod-i18n';
import { getRuntimeRecaptchaSiteKey } from './shared';
import { useEffect } from 'react';

function useRecaptcha() {
	useEffect(() => {
		// Warm up api.js on mount so a token is ready by the time the user submits. The load is a shared,
		// cached promise, so this doesn't race or double-inject with the submit-time load.
		void loadRecaptcha(getRuntimeRecaptchaSiteKey());
	}, []);
}

export const useAppForm: typeof useAppFormBase = (...args) => {
	useZodI18n();
	useRecaptcha();
	return useAppFormBase(...args);
};
